import React, { Component } from 'react'
import {Card, IconButton, Divider, Typography,Grid, CardContent, Box,CircularProgress} from '@material-ui/core'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import wxpayimg from "../../images/wxpay.png"
import alipayimg from "../../images/alipay.png"
import {getLocalUsrInfo,handleError,writelog,getApiDomain} from "../../utils"


export default function QRPay(props) {

    //console.log("props:",props,props.TradeNo)

    var queryNum = 0 
    var intervalJob

    const queryTrade = async function(){
        clearInterval(intervalJob)
        queryNum++

        var usr = getLocalUsrInfo()
        var reqData ={
          UserID: usr.UserID,
          OutTradeNo: props.TradeNo
        }
        let response = await fetch(getApiDomain()+'/users/QueryTrade/'+usr.UserID+'?rnd='+Math.random()*999,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'sessionid': usr.SessionID
            },
            body: JSON.stringify(reqData)
        }).catch(handleError);
        if(response.ok){
            let resData = await response.json();
            if(resData.Result ===0 && resData.TradeStatus ===1) {

                window.location.href = "https://pay.xwglive.com/onlinepay/success.html"
                return 
            } else if(queryNum >60) {
                writelog("queryTrade","timeout")
                window.location.href = "https://pay.xwglive.com/onlinepay/canceled.html"
                return 
            }
        } else {
            writelog("queryTrade","response fail",response)
        }       
        intervalJob = setInterval(queryTrade,1000)
    }

    intervalJob = setInterval(queryTrade,2000)

    return (
    <Box display="flex" justifyContent="center" m={1} p={1} >
        <Card  variant='outlined' style={{padding:0}}>
            <Grid justify="space-between" container space={24}>
                <Grid item>
                    <IconButton size="small" onClick={()=>{clearInterval(intervalJob);queryNum=100;window.location.href="#/"}} >
                        <KeyboardBackspaceIcon style={{width:24,height:24,padding:4}} ></KeyboardBackspaceIcon>
                    </IconButton>
                </Grid>
                <Grid item >
                    <Typography variant="body2" ></Typography>
                </Grid>
            </Grid>
            <Divider style={{marginTop:4}} light />
            <CardContent style={{display:"block"}}>
                <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                style={{padding:0}}
                >
                    <Grid item xs={0}>
                        <img src={props.PayQRImg} ></img>
                    </Grid>  
                    <Grid item xs={0}>
                        <CircularProgress color="primary" style={{width:24,height:24,padding:0}}/>
                    </Grid>   
                </Grid> 
            </CardContent>
            <Divider style={{margin:4}}></Divider>
            <CardContent style={{textAlign:"center"}}>
                <img src={props.PayChannel == "wxpay"?wxpayimg:alipayimg} style={props.PayChannel == "wxpay"?{width:128,height:32}:{width:96,height:32}}></img>
            </CardContent>
        </Card> 
    </Box>
    )
}
